import React from 'react';
import { CheckCircle2, Users, Brain, Zap, Trophy } from 'lucide-react';
const checkItems = [{
  icon: Zap,
  text: 'Estás harto de terminar el día scrolleando el celular o mirando series que ya no te sorprenden y buscás una experiencia de suspenso real que podés vivir desde el sillón de tu casa.'
}, {
  icon: Users,
  text: 'Buscás una conexión real con tu pareja o amigos: Querés un plan distinto para el fin de semana donde el trabajo en equipo y la adrenalina de resolver un crimen los mantenga atrapados hasta la última página.'
}, {
  icon: Brain,
  text: 'Querés poner a prueba tus capacidades: Sabés que tenés un instinto detective agudo y buscás un desafío a tu altura que te obligue a pensar fuera de la caja.'
}, {
  icon: Zap,
  text: 'Necesitás escapar de la rutina diaria: Te aseguramos una inmersión total donde los problemas del trabajo desaparecen para dejar lugar a la única pregunta que importa: ¿Quién cometió el crimen?'
}, {
  icon: Trophy,
  text: 'Deseás esa satisfacción única de conectar el último hilo rojo en tu tablero, mirar a los ojos a quien te acompaña y decir con absoluta certeza: "Caso Cerrado".'
}];
export function PainSection() {
  return <section className="py-20 px-4 bg-[#111] border-b border-[#333]" data-id="element-132">
      <div className="max-w-4xl mx-auto" data-id="element-133">
        {/* Header */}
        <div className="mb-14 text-center" data-id="element-134">
          <div className="inline-block border border-[#c8b89a]/30 bg-[#c8b89a]/5 px-4 py-1 rounded-sm mb-6" data-id="element-135">
            <p className="text-[#c8b89a] font-mono text-xs tracking-widest uppercase font-bold" data-id="element-136">
              🕵️‍♂️ Para quién es esto
            </p>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white font-['Special_Elite'] mb-4" data-id="element-137">
            DISFRUTÁ DE UNA EXPERIENCIA
            <br className="hidden md:block" data-id="element-138" /> FUERA DE LA RUTINA
          </h2>
          <div className="h-0.5 w-24 bg-[#cc2200] mx-auto mb-6" data-id="element-139"></div>
          <p className="text-xl text-[#c8b89a] font-['Special_Elite']" data-id="element-140">
            ESTOS CASOS CRIMINALES SON PARA VOS SI...
          </p>
        </div>

        {/* Before/After Image */}
        <div className="mb-14 rounded-sm overflow-hidden shadow-2xl border border-[#333]" data-id="element-141">
          <img src="https://cdn.magicpatterns.com/uploads/9vGnxRfBfojKw7kkURvgcK/ChatGPT_Image_21_nov_2025_00_42_18.webp" alt="Antes: aburrimiento. Después: investigando juntos" className="w-full object-cover" data-id="element-142" />
        </div>

        {/* Checklist */}
        <div className="space-y-5 mb-16" data-id="element-143">
          {checkItems.map((item, i) => <div key={i} className="flex items-start gap-4 bg-[#0a0a0a] border border-[#222] p-5 rounded-sm" data-id="element-144">
              <CheckCircle2 className="w-6 h-6 text-[#cc2200] flex-shrink-0 mt-0.5" data-id="element-145" />
              <p className="text-gray-300 text-base leading-relaxed font-mono" data-id="element-146">
                {item.text}
              </p>
            </div>)}
        </div>

        {/* Immersive Block */}
        <div className="bg-[#0d0d0d] border-l-4 border-[#cc2200] p-8 rounded-sm shadow-xl" data-id="element-147">
          <p className="text-[#c8b89a] font-['Special_Elite'] text-xl md:text-2xl font-bold mb-4 uppercase tracking-wide" data-id="element-148">
            🌑 Una experiencia completamente inmersiva
          </p>
          <p className="text-gray-300 font-mono text-base leading-relaxed mb-4" data-id="element-149">
            Si buscás algo más que un simple juego, esto es para vos. Nuestros
            casos están diseñados para sacarte de la monotonía y sumergirte en
            un mundo de suspenso, pistas falsas y giros inesperados.
          </p>
          <p className="text-gray-300 font-mono text-base leading-relaxed" data-id="element-150">
            Es el plan perfecto para convertir una noche común en una{' '}
            <strong className="text-white bg-[#cc2200]/20 px-1" data-id="element-151">
              investigación de alto riesgo que no vas a olvidar.
            </strong>
          </p>
        </div>
      </div>
    </section>;
}